module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sobre"
    }
  }, [_c('bloco-texto', {
    staticClass: "-rightalign",
    attrs: {
      "imagem": "static/imagem_padrao.jpg",
      "rota": 'apresentacao'
    }
  }, [_c('template', {
    slot: "titulo"
  }, [_vm._v("O que é a PROAD?")]), _c('template', {
    slot: "texto"
  }, [_vm._v("A PROAD é o órgão responsável pela supervisão e coordenação das áreas de contabilidade, finanças, material, patrimônio, segurança, transportes e serviços gerais da UFRN.")])], 2), _c('bloco-texto', {
    staticClass: "-leftalign",
    attrs: {
      "imagem": "static/imagem_padrao.jpg",
      "rota": 'acoes'
    }
  }, [_c('template', {
    slot: "titulo"
  }, [_vm._v("Conheça nossas ações")]), _c('template', {
    slot: "texto"
  }, [_vm._v("Dentre às diversas ações que a PROAD está executando, destacamos a contribuição para a elaboração do PLS - Plano de Gestão de Logística Sustentável da UFRN.")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c07dbe00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Sobre.vue
// module id = 512
// module chunks = 0